import { render, staticRenderFns } from "./ImportSupplies.vue?vue&type=template&id=71dba907&"
import script from "./ImportSupplies.vue?vue&type=script&lang=js&"
export * from "./ImportSupplies.vue?vue&type=script&lang=js&"
import style0 from "./ImportSupplies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports